import _ from 'lodash';
import React, { useState } from 'react';
import { gql, useApolloClient } from '@apollo/client';
import { Breadcrumb, Button, Input, Popconfirm } from 'antd';
import ReactTable from 'react-table';
import { isAdmin } from '@achievable-me/tundra-wizard/auth';
import Spinner from '$components/library/Spinner';
import storage from '$lib/storage';
import UserDetails from './UserDetails';
import styles from './styles.scss';

const STAFF_USER_SEARCH = gql`
  query StaffUserSearch($input: StaffUserSearchInput!) {
    staffUserSearch(input: $input) {
      users {
        uuid
        email
        nickname
        source
        promo
        accessToken
        organization {
          uuid
          name
        }
      }
    }
  }
`;

const impersonate =
  ({ user }) =>
  () => {
    const { accessToken, email } = user;
    storage.setAuth({ email, accessToken, isImpersonated: true });
    window.location.href = '/';
  };

const Users = (props) => {
  const client = useApolloClient();
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);

  const handleOnSearch = async ({ client, value }) => {
    setLoading(true);
    const { data } = await client.query({
      query: STAFF_USER_SEARCH,
      variables: { input: { query: value } },
    });
    const {
      staffUserSearch: { users: usersData },
    } = data;

    setLoading(false);
    setUsers(usersData);
  };

  const renderUsers = () => {
    const { currentUser } = props;
    if (loading) {
      return <Spinner />;
    }

    if (users.length === 0) {
      return <div>No matches.</div>;
    }

    return (
      <ReactTable
        columns={[
          {
            id: 'email',
            Header: 'email',
            accessor: 'email',
          },
          {
            id: 'source',
            Header: 'source',
            accessor: 'source',
          },
          {
            id: 'organization',
            Header: 'organization',
            accessor: (row) => _.get(row, 'organization.name'),
          },
        ]}
        data={users}
        className="-striped -highlight"
        SubComponent={(row) => {
          const { original } = row;
          const user = original;
          return (
            <div className={styles.detailsLayout}>
              <UserDetails user={user} currentUser={currentUser} />
              {isAdmin(currentUser) && (
                <Popconfirm title="Are you sure?" onConfirm={impersonate({ user })}>
                  <Button>Impersonate</Button>
                </Popconfirm>
              )}
            </div>
          );
        }}
      />
    );
  };

  return (
    <div className={styles.layout}>
      <Breadcrumb>
        <Breadcrumb.Item>Users</Breadcrumb.Item>
      </Breadcrumb>
      <br />
      <Input.Search
        placeholder="input search text"
        onSearch={(value) => handleOnSearch({ client, value })}
        enterButton
        style={{ width: '300px' }}
        data-aaa="userSearch"
      />
      <br />
      <br />
      {renderUsers()}
    </div>
  );
};

export default Users;
